import notifyErrorDefaults from "../constants/notifyErrorDefaults";
import apiBaseState from "~/constants/apiBaseState";

export const state = () => ({
    profileGroups: null,
    profileGroupsState: apiBaseState(),
    createProfileGroupCategoryState: apiBaseState(),
    updateProfileGroupCategoryState: apiBaseState(),
    deleteProfileGroupCategoryState: apiBaseState(),
    createProfileGroupsState: apiBaseState(),
    updateProfileGroupsState: apiBaseState(),
    deleteProfileGroupsState: apiBaseState(),
    projectProfileGroupsProject: null
});

export const getters = {
    showLoader(state) {
        return state.deleteProfileGroupsState.loading
        || state.deleteProfileGroupCategoryState.loading
        || state.updateProfileGroupsState.loading;
    }
};

export const mutations = {
    SET_PROJECT_PROFILE_GROUPS_PROJECT(state, payload){
        state.projectProfileGroupsProject = payload;
    },
    SET_PROFILE_GROUPS(state, data) {
        state.profileGroups = data;
    },
    SET_CREATE_PROFILE_GROUP_STATE(state, data) {
        state.createProfileGroupsState = data;
    },
    SET_UPDATE_PROFILE_GROUP_STATE(state, data) {
        state.updateProfileGroupsState = data;
    },
    SET_PROJECT_PROFILE_GROUPS_STATE(state, data) {
        state.profileGroupsState = data;
    },
    SET_PROJECT_PROFILE_GROUPS_DATA(state, groups) {
        state.profileGroupsState.data = [...groups];
    },
    PUSH_PROJECT_PROFILE_GROUPS_DATA(state, data) {
        state.profileGroupsState.data.push(data);
    },
    SET_CREATE_PROFILE_GROUP_CATEGORY_STATE(state, data) {
        state.createProfileGroupCategoryState = data;
    },
    SET_UPDATE_PROFILE_GROUP_CATEGORY_STATE(state, data) {
        state.updateProfileGroupCategoryState = data;
    },
    SET_DELETE_PROFILE_GROUP_CATEGORY_STATE(state, data) {
        state.deleteProfileGroupCategoryState = data;
    },
    SET_DELETE_PROFILE_GROUP_STATE(state, data) {
        state.deleteProfileGroupsState = data;
    },
};

export const actions = {

    CREATE_PROFILE_GROUP(state, data) {
        const {accountSlug, projectSlug, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/settings/profile-groups`;
        return this.$whyApi.post({
            url,
            data: payload,
            mutation: "profileGroups/SET_CREATE_PROFILE_GROUP_STATE",
            errorMessage: "Error creating profile group",
            notify: this.$notify
        });
    },
    UPDATE_PROFILE_GROUP(state, data) {
        const {accountSlug, projectSlug, groupId, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/settings/profile-groups/${groupId}`;
        return this.$whyApi.put({
            url,
            data: payload,
            mutation: "profileGroups/SET_CREATE_PROFILE_GROUP_STATE",
            errorMessage: "Error creating profile group",
            notify: this.$notify
        });
    },
    DELETE_PROFILE_GROUP(state, data) {
        const {accountSlug, projectSlug, groupId} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/settings/profile-groups/${groupId}`;
        return this.$whyApi.delete({
            url,
            mutation: "profileGroups/SET_DELETE_PROFILE_GROUP_STATE",
            errorMessage: "Error deleting profile group",
            notify: this.$notify
        });
    },
    CREATE_PROFILE_GROUP_CATEGORY(state, data) {
        const {accountSlug, projectSlug, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/settings/profile-group-categories`;
        return this.$whyApi.post({
            url,
            data: payload,
            mutation: "profileGroups/SET_CREATE_PROFILE_GROUP_CATEGORY_STATE",
            errorMessage: "Error creating profile group category",
            notify: this.$notify
        });
    },
    UPDATE_PROFILE_GROUP_CATEGORY(state, data) {
        const {accountSlug, projectSlug, categoryId, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/settings/profile-group-categories/${categoryId}`;
        return this.$whyApi.put({
            url,
            data: payload,
            mutation: "profileGroups/SET_UPDATE_PROFILE_GROUP_CATEGORY_STATE",
            errorMessage: "Error creating profile group category",
            notify: this.$notify
        });
    },
    DELETE_PROFILE_GROUP_CATEGORY(state, data) {
        const {accountSlug, projectSlug, categoryId} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/settings/profile-group-categories/${categoryId}`;
        return this.$whyApi.delete({
            url,
            mutation: "profileGroups/SET_DELETE_PROFILE_GROUP_CATEGORY_STATE",
            errorMessage: "Error deleting profile group category",
            notify: this.$notify
        });
    },
    GET_PROJECT_PROFILE_GROUPS(context, data) {
        const {accountSlug, projectSlug, forceRequest} = data;
        if(forceRequest || context.state.projectProfileGroupsProject !== projectSlug){
        context.commit('SET_PROJECT_PROFILE_GROUPS_PROJECT', projectSlug);
        const url = `/accounts/${accountSlug}/${projectSlug}/settings/profile-group-categories`;
        return this.$whyApi.get({
            url,
            mutation: "profileGroups/SET_PROJECT_PROFILE_GROUPS_STATE",
            errorMessage: "Error getting profile groups",
            notify: this.$notify
        });
        }
    },
    async GET_PROFILE_GROUPS({commit}, data) {
        const {path, $notify} = data;
        try {
            const response = await this.$api.fetchProfileGroupCategories(path);
            commit("SET_PROFILE_GROUPS", response.data);
        } catch (e) {
            console.log(e);
            $notify({
                ...notifyErrorDefaults,
                text: 'Error loading questions for quota'
            });
        }
    }
};
